export const FirebaseConfig = {
	"projectId": "servitaximexico",
	"appId": "1:1058824006802:web:705a1d74de258dd50f4a4b",
	"databaseURL": "https://servitaximexico-default-rtdb.firebaseio.com",
	"storageBucket": "servitaximexico.firebasestorage.app",
	"apiKey": "AIzaSyCw1RDlZpNk31Km-o4C6v-Cia7LStg_hoA",
	"authDomain": "servitaximexico.firebaseapp.com",
	"messagingSenderId": "1058824006802",
	"measurementId": "G-T1JE83WCYH",
	"projectNumber": "1058824006802",
	"version": "2"
};